import React from 'react';
import Heading from '../../common/Heading';
import './recent.css';
import RecentCard from './RecentCard';

function Recent() {
  return (
    <>
    <section className='recent padding'>
      <div className='container'>
        <Heading 
          title='Recent Property Listed' 
          subtitle= 'Discover our latest property listings, carefully curated to meet your needs. Our selection includes a variety of options designed to provide comfort and convenience for your lifestyle.' 
        />
        <RecentCard />
      </div>
    </section>
    </>
  )
}

export default Recent;
